const normalizeLabel = value =>
  typeof value === 'string' && value.trim().length > 0 ? value.trim() : '';

/**
 * Build a consistent label for timeline points from an item label and a num label.
 * @param {string} itemLabel
 * @param {string} numLabel
 * @param {object} options
 * @param {string} options.fallbackItemLabel used when itemLabel is empty
 * @param {string} options.fallbackNumLabel used when numLabel is empty
 * @param {string} options.emptyFallback used when both labels are empty
 * @returns {string}
 */
export const buildTimelineEntryLabel = (
  itemLabel,
  numLabel,
  {
    fallbackItemLabel = '',
    fallbackNumLabel = '',
    emptyFallback = 'Entrée',
  } = {}
) => {
  const safeItem = normalizeLabel(itemLabel) || normalizeLabel(fallbackItemLabel);
  const safeNum = normalizeLabel(numLabel) || normalizeLabel(fallbackNumLabel);
  if (safeItem && safeNum) {
    return `${safeItem} — ${safeNum}`;
  }
  if (safeItem) {
    return safeItem;
  }
  if (safeNum) {
    return safeNum;
  }
  return emptyFallback;
};
